import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './HowItWorks.css';

const HowItWorks = () => {
  const companyLogos = [
    { 
      name: 'Google', 
      logo: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
        </svg>
      ) 
    },
    { 
      name: 'Amazon', 
      logo: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M13.9 14.8c-2.3 1.7-5.7 2.6-8.6 2.6-4.1 0-7.8-1.5-10.6-4-.2-.2-.2-.5 0-.7.4-.4.8-.8 1.2-1.1.2-.2.5-.1.7.1 2.3 2 5.3 3.2 8.6 3.2 2.4 0 5.2-.7 7.3-2.1.3-.2.7 0 .8.3.3.4.6.9.9 1.4.1.3 0 .5-.3.6z"/>
          <path d="M15.1 13.5c-.3-.4-1.9-.2-2.6-.1-.2 0-.3-.2-.2-.3.7-1 2.5-1.4 3.2-.6.7.8.2 2.7-.5 3.7-.1.2-.3.1-.3 0-.1-.8.2-2.4-.1-2.7z"/>
          <path d="M13.7 9.8c0-1.7-.8-2.5-2.2-2.5-1.5 0-2.3.9-2.3 2.5v2.8c0 1.6.8 2.5 2.3 2.5 1.4 0 2.2-.8 2.2-2.5V9.8zm2.4 2.7c0 3-1.8 4.6-4.6 4.6-2.8 0-4.6-1.6-4.6-4.6V9.9c0-3 1.8-4.6 4.6-4.6 2.8 0 4.6 1.6 4.6 4.6v2.6z"/>
        </svg>
      ) 
    },
    { 
      name: 'Apple', 
      logo: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.38c.62-.75 1.04-1.8 0.92-2.88-.9.04-1.99.6-2.63 1.35-.57.65-1.07 1.72-.94 2.76 1 .08 2.03-.49 2.65-1.23"/>
        </svg>
      ) 
    },
    { 
      name: 'Microsoft', 
      logo: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M1 1h10v10H1zM13 1h10v10H13zM1 13h10v10H1zM13 13h10v10H13z"/>
        </svg>
      ) 
    },
    { 
      name: 'Meta', 
      logo: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M6.9 7.6c-2.8 0-5.1 2.2-5.1 5.3 0 2.6 1.7 4.7 4.1 4.7 2 0 3.5-1.3 4.6-3.1l1.5-2.5 1.5 2.5c1.1 1.8 2.6 3.1 4.6 3.1 2.4 0 4.1-2.1 4.1-4.7 0-3.1-2.3-5.3-5.1-5.3-2 0-3.6 1.1-4.6 2.8L12 11.4l-1.5-2c-1-1.7-2.6-2.8-4.6-2.8zm-1 3.5c1.4 0 2.5 1.2 3.1 2.4-.6 1.2-1.7 2.4-3.1 2.4-1.2 0-2.2-1.1-2.2-2.4 0-1.3 1-2.4 2.2-2.4zm12.2 0c1.2 0 2.2 1.1 2.2 2.4 0 1.3-1 2.4-2.2 2.4-1.4 0-2.5-1.2-3.1-2.4.6-1.2 1.7-2.4 3.1-2.4z"/>
        </svg>
      ) 
    },
    { 
      name: 'Netflix', 
      logo: (
        <svg width="16" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M4 0h4v17l8-17h4v24h-4V7L8 24H4V0z"/>
        </svg>
      ) 
    },
    { 
      name: 'Nvidia', 
      logo: (
        <svg width="20" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.003 3.6c-4.48 0-8.15 3.32-8.73 7.64.67-.84 1.5-1.51 2.43-1.97.35-2.54 2.52-4.52 5.17-4.52 2.88 0 5.22 2.34 5.22 5.22 0 1.94-1.07 3.63-2.66 4.54l1.64 1.64c2.27-1.42 3.8-3.86 3.8-6.68 0-4.42-3.58-8-8.01-8l.14.17zm.003 4.56c-1.89 0-3.42 1.53-3.42 3.42 0 .9.35 1.72.92 2.33l2.84-2.84V8.16zm-5.63 4.29c-.06.27-.09.55-.09.84 0 2.43 1.97 4.4 4.4 4.4.92 0 1.77-.28 2.47-.77l1.73 1.73c-1.2 .83-2.65 1.32-4.2 1.32-4.09 0-7.4-3.31-7.4-7.4 0-.82.14-1.61.39-2.35l2.29 2.23h.4zm5.63 7.82c-4.97 0-9-4.03-9-9 0-.48.04-.96.12-1.42L1.4 7.74C1.14 8.76 1 9.84 1 10.95c0 6.07 4.93 11 11 11 3.56 0 6.74-1.7 8.76-4.34l-2.06-1.57c-1.53 1.97-3.93 3.23-6.69 3.23z"/>
        </svg>
      ) 
    },
    { 
      name: 'Tesla', 
      logo: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 4.5c3.2 0 6.1.9 8.5 2.4l.8-2C18.5 3.2 15.4 2.2 12 2.2S5.5 3.2 2.7 4.9l.8 2C5.9 5.4 8.8 4.5 12 4.5zm0 3.3c-2.4 0-4.6.6-6.4 1.7l1.1 2.8c1.5-.8 3.3-1.3 5.3-1.3s3.8.5 5.3 1.3l1.1-2.8c-1.8-1.1-4-1.7-6.4-1.7zm1.1 6.5V22h-2.2v-7.7c-2.8.2-4.8 1.1-6.1 2.4l-.8-2.6c1.6-1.5 4.3-2.5 7.9-2.7h.2c3.6.2 6.3 1.2 7.9 2.7l-.8 2.6c-1.3-1.3-3.3-2.2-6.1-2.4z"/>
        </svg>
      ) 
    },
    { 
      name: 'Uber', 
      logo: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <rect x="3" y="3" width="18" height="18" rx="4" fill="none" stroke="currentColor" strokeWidth="2.2"/>
          <path d="M8 8v5a4 4 0 0 0 8 0V8" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
        </svg>
      ) 
    },
    { 
      name: 'Stripe', 
      logo: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697.5 12.836.5 6.675.5 2.616 3.657 2.616 8.775c0 5.485 5.568 6.55 8.948 7.828 2.378.898 3.189 1.587 3.189 2.61 0 .937-.812 1.488-2.227 1.488-2.736 0-5.592-1.22-7.51-2.213l-.946 5.567c1.782.87 4.908 1.445 8.082 1.445 6.438 0 10.748-3.084 10.748-8.314 0-5.183-5.228-6.613-8.924-8.036z"/>
        </svg>
      ) 
    }
  ];

  const stepsData = [
    {
      step: '01',
      badge: 'BEFORE CALL',
      title: 'Profile Setup',
      desc: 'Upload your resume. AI adapts hints to your target role and tech stack.',
      renderVisual: () => (
        <div className="flow-visual-card">
          <div className="flow-card-header">
            <span className="flow-card-title">Copilot Setup Engine</span>
            <span className="status-live-pill">READY</span>
          </div>
          <div className="flow-items-list">
            <div className="flow-item-row active-row">
              <div className="flow-item-icon bg-blue">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><line x1="16" x2="8" y1="13"/><line x1="16" x2="8" y1="17"/><line x1="10" x2="8" y1="9"/></svg>
              </div>
              <div className="flow-item-info">
                <span className="flow-item-name">Resume & Skills</span>
                <span className="flow-item-sub">Full Stack / Systems</span>
              </div>
              <span className="flow-check-icon">✓</span>
            </div>

            <div className="flow-item-row active-row">
              <div className="flow-item-icon bg-purple">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect width="20" height="14" x="2" y="3" rx="2"/><line x1="8" x2="16" y1="21" y2="21"/><line x1="12" x2="12" y1="17" y2="21"/></svg>
              </div>
              <div className="flow-item-info">
                <span className="flow-item-name">Job Requirements</span>
                <span className="flow-item-sub">L5 Distributed Systems</span>
              </div>
              <span className="flow-check-icon">✓</span>
            </div>

            <div className="flow-item-row active-row">
              <div className="flow-item-icon bg-emerald">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/></svg>
              </div>
              <div className="flow-item-info">
                <span className="flow-item-name">Audio Whisper Engine</span>
                <span className="flow-item-sub">Hardware Mic Active</span>
              </div>
              <span className="flow-check-icon">✓</span>
            </div>
          </div>
        </div>
      )
    },
    {
      step: '02',
      badge: 'LIVE CALL',
      title: 'Live Copilot',
      desc: 'Real-time algorithms and architecture answers streamed discreetly.',
      renderVisual: () => (
        <div className="flow-visual-card">
          <div className="flow-card-header">
            <span className="flow-card-title">Live Interview Copilot</span>
            <span className="status-live-pill pill-green">ACTIVE FEED</span>
          </div>
          <div className="live-chat-preview">
            <div className="chat-bubble-interviewer">
              <div className="bubble-speaker">Alex (Interviewer):</div>
              <div className="bubble-text interviewer-question-text">"How do you design an LRU Cache with O(1) get and put operations?"</div>
            </div>

            <div className="chat-bubble-copilot">
              <div className="bubble-speaker-copilot">
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                  </svg>
                  CrackIT Copilot:
                </span>
                <span className="badge-fast">180ms</span>
              </div>
              <div className="bubble-text-copilot">
                "Use a <strong>Hash Map + Doubly Linked List</strong>. O(1) key lookups via Hash Map, and O(1) recency ordering via Doubly Linked List."
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      step: '03',
      badge: 'AFTER CALL',
      title: 'Review & Insights',
      desc: 'Review question breakdowns, audio logs, and solutions anytime.',
      renderVisual: () => (
        <div className="flow-visual-card">
          <div className="flow-card-header">
            <span className="flow-card-title">Session History</span>
            <span className="status-live-pill">SAVED</span>
          </div>

          <div className="scores-gauge-grid">
            <div className="score-gauge-item">
              <div className="score-ring-wrapper">
                <svg className="score-svg" viewBox="0 0 36 36">
                  <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                  <path className="circle-val ring-blue" strokeDasharray="85, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                </svg>
                <span className="score-number">8.5</span>
              </div>
              <span className="score-label">Relevance</span>
            </div>

            <div className="score-gauge-item">
              <div className="score-ring-wrapper">
                <svg className="score-svg" viewBox="0 0 36 36">
                  <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                  <path className="circle-val ring-green" strokeDasharray="92, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                </svg>
                <span className="score-number">9.2</span>
              </div>
              <span className="score-label">Accuracy</span>
            </div>

            <div className="score-gauge-item">
              <div className="score-ring-wrapper">
                <svg className="score-svg" viewBox="0 0 36 36">
                  <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                  <path className="circle-val ring-purple" strokeDasharray="88, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                </svg>
                <span className="score-number">8.8</span>
              </div>
              <span className="score-label">Clarity</span>
            </div>
          </div>

          <div className="feedback-highlights">
            <div className="feedback-bar-item">
              <span className="fb-text">Audio Q&A log archived</span>
              <span className="fb-badge green">Saved</span>
            </div>
            <div className="feedback-bar-item">
              <span className="fb-text">Code & design solutions stored</span>
              <span className="fb-badge blue">Exportable</span>
            </div>
          </div>
        </div>
      )
    }
  ];

  return (
    <section className="how-it-works-section" id="how-it-works">
      
      {/* Company Ticker */}
      <div className="company-marquee-block">
        <h3 className="marquee-title">ENGINEERS HIRED AT</h3>
        <div className="marquee-container">
          <div className="marquee-track animate-marquee">
            {[...companyLogos, ...companyLogos].map((c, i) => (
              <div key={i} className="company-logo-pill">
                <span className="company-logo-icon">{c.logo}</span>
                <span className="company-brand-name">{c.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main 3-Step Section */}
      <div className="how-it-works-container">
        
        <motion.div 
          className="section-header-centered"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <div className="badge-pill">HOW IT WORKS</div>
          <h2 className="section-main-title">
            Three Simple <span className="gradient-primary">Steps.</span>
          </h2>
          <p className="section-main-subtitle">
            Set up your profile, get stealth answers live, and review transcripts.
          </p>
        </motion.div>

        {/* 3 Step Bento Cards Grid */}
        <div className="steps-bento-grid">
          {stepsData.map((item, index) => (
            <motion.div 
              key={index}
              className="step-bento-card glass-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
            >
              {/* Card Text & Step Indicator Header */}
              <div className="card-info-area">
                <div className="step-badge-row">
                  <span className="step-circle-number">{item.step}</span>
                  <span className="step-phase-tag">{item.badge}</span>
                </div>
                <h3 className="step-card-title">{item.title}</h3>
                <p className="step-card-desc">{item.desc}</p>
              </div>

              {/* Card Interactive Preview Visual */}
              <div className="card-visual-wrapper">
                {item.renderVisual()}
              </div>
            </motion.div>
          ))}
        </div>

      </div>

    </section>
  );
};

export default HowItWorks;
